import { QuestionBase } from './question-base';

export class ReadOnlyQuestion extends QuestionBase<string> {
  controlType = 'read-only';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
